import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowRight, Car, Wrench, Zap, Wind } from 'lucide-react'

const ServicesPreview = () => {
  const services = [
    {
      icon: Car,
      title: 'Обработка днища',
      description: 'Полная защита днища автомобиля от коррозии, включая арки колес и скрытые полости',
      price: 'от 600 BYN',
      features: ['Очистка от грязи', 'Обезжиривание', 'Нанесение защитного состава', 'Гарантия 5 лет']
    },
    {
      icon: Wrench,
      title: 'Обработка скрытых полостей',
      description: 'Защита внутренних полостей кузова, дверей и капотов от коррозии',
      price: 'от 300 BYN',
      features: ['Очистка полостей', 'Антикоррозийная обработка', 'Защита от влаги', 'Гарантия 5 лет']
    },
    {
      icon: Wind,
      title: 'Пескоструйная очистка',
      description: 'Профессиональная очистка кузова и днища от ржавчины и старой краски',
      price: 'от 600 BYN',
      features: ['Очистка от ржавчины', 'Удаление старой краски', 'Подготовка к покраске', 'Гарантия 1 год']
    },
    {
      icon: Zap,
      title: 'Комплексная обработка',
      description: 'Полная антикоррозийная обработка всего автомобиля',
      price: 'от 800 BYN',
      features: ['Все виды обработки', 'Скидка 15%', 'Расширенная гарантия', 'Бесплатная диагностика', 'Гарантия 5 лет']
    }
  ]

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
            Наши услуги
          </h2>
          <p className="text-lg text-secondary-600 max-w-3xl mx-auto">
            Предлагаем полный спектр услуг по антикоррозийной обработке автомобилей
            с использованием современных технологий и качественных материалов
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <div className="card h-full flex flex-col hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
                {/* Icon */}
                <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary-200 transition-colors duration-200">
                  <service.icon className="w-8 h-8 text-primary-600" />
                </div>

                {/* Content */}
                <div className="flex-grow">
                  <h3 className="text-xl font-semibold text-secondary-900 mb-3 group-hover:text-primary-600 transition-colors duration-200">
                    {service.title}
                  </h3>
                  <p className="text-secondary-600 mb-4 text-sm leading-relaxed">
                    {service.description}
                  </p>

                  {/* Features */}
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm text-secondary-600">
                        <div className="w-2 h-2 bg-primary-400 rounded-full mr-3 flex-shrink-0" />
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/* Price */}
                  <div className="text-2xl font-bold text-primary-600 mb-4">
                    {service.price}
                  </div>
                </div>

                {/* CTA */}
                <div className="mt-auto">
                  <Link
                    to="/services"
                    className="inline-flex items-center text-primary-600 font-medium hover:text-primary-700 transition-colors duration-200 group-hover:translate-x-1 transform"
                  >
                    Подробнее
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <div className="bg-gradient-to-r from-primary-50 to-accent-50 rounded-2xl p-8 md:p-12">
            <h3 className="text-2xl md:text-3xl font-bold text-secondary-900 mb-4">
              Нужна консультация?
            </h3>
            <p className="text-lg text-secondary-600 mb-6 max-w-2xl mx-auto">
              Наши специалисты помогут подобрать оптимальный вариант обработки
              для вашего автомобиля и ответят на все вопросы
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="btn-primary">
                Получить консультацию
              </Link>
              <Link to="/services" className="btn-secondary">
                Все услуги
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default ServicesPreview
